import mockApi from '../mock-api.json';
import mock from '../mock';

const { userRole } = mockApi.components.examples;

console.log("userRole", userRole);

mock.onGet('/roles').reply(() => {
  return [200, userRole];
});
